import { request } from '@langlois/request';

export async function getDocuments ({ commit }, competitionId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}/document`);

		const response = await request.get(url);

		if (response.ok) {
			const documents = await response.json();

			commit(`setDocuments`, { competitionId, documents });
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the competition's documents.`,
			type: `warning`
		}, { root: true });
	}
}
